var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRegistereduser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "38px",
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u767B\u5F55") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-202.000000, -130.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u767B\\u5F55",
    transform: "translate(202.000000, 130.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#2878FF",
    cx: 19,
    cy: 18.7246377,
    rx: 19,
    ry: 18.7246377
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-wodexiao",
    transform: "translate(10.000000, 9.855072)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00225,11.826087 C17.325,11.826087 17.2425,16.903913 17.2425,16.903913 C17.3055,17.3651304 16.968,17.7391304 16.488,17.7391304 L1.5165,17.7391304 C1.03649999,17.7391304 0.680250006,17.3599565 0.761999994,16.903913 C0.761999994,16.903913 0.677999988,11.826087 9.00225,11.826087 Z M9,0 L14.25,0 L14.25,5.17391305 C14.25,8.03138632 11.8994949,10.3478261 9,10.3478261 C6.10050506,10.3478261 3.74999999,8.03138632 3.74999999,5.17391305 C3.74999999,2.31643978 6.10050506,0 9,0 Z",
    id: "\\u5F62\\u72B6"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistereduser);
export default __webpack_public_path__ + "static/media/registereduser.5c87116f8c42536fb26716621399fed3.svg";
export { ForwardRef as ReactComponent };